import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { Field } from 'redux-form';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import CreateIcon from 'material-ui/svg-icons/content/create';
import IconButton from 'material-ui/IconButton';

import { Grid } from '../../components';
import { ActiveCell, MailTo } from '../shared';
import enhancer from '../enhancer';

class Users extends Component {
  handleEditUser = userId => {
    const { history } = this.props;
    history.push(`/admin/user/${userId}`);
  };

  handleLoadMore = () => {
    this.props.relay.setVariables({
      first: this.props.relay.variables.first + 10,
    });
  };

  handleSearch = () => {
    // Need to set timeout for blur
    setTimeout(() => {
      const filters = Object.assign(
        {
          email: null,
        },
        this.props.filterValues
      );

      this.props.relay.setVariables(filters);
    }, 0);
  };

  renderRow = ({ node }) => {
    const { id, roles, email } = node;

    return (
      <TableRow key={id}>
        <TableRowColumn>
          <MailTo value={email} />
        </TableRowColumn>

        <TableRowColumn>
          <ActiveCell active={node.active} />
        </TableRowColumn>
        <TableRowColumn>
          {roles.edges.map(edge => edge.node.name).join(', ')}
        </TableRowColumn>
        <TableRowColumn>
          <IconButton
            onClick={() => {
              this.handleEditUser(node.id);
            }}
          >
            <CreateIcon />
          </IconButton>
        </TableRowColumn>
      </TableRow>
    );
  };

  render() {
    const { allUsers } = this.props.admin;

    const { edges, pageInfo } = allUsers;

    const onKeyDown = event => {
      if (event.key === 'Enter') {
        this.handleSearch();
      }
    };

    const headers = [
      <Field
        name="email"
        floatingLabelText="Email"
        component={TextField}
        onKeyDown={onKeyDown}
      />,
      'Active',
      'Roles',
      'Actions',
    ];

    return (
      <div>
        <Grid headers={headers} renderRow={this.renderRow} rows={edges} />

        <RaisedButton
          disabled={!pageInfo.hasNextPage}
          label="Load More"
          secondary
          onClick={this.handleLoadMore}
        />
      </div>
    );
  }
}

const query = graphql`
  query UsersAdminQuery($first: Int, $email: String) {
    admin {
      ...Users_admin
    }
  }
`;

export default enhancer(Users, {
  mapStateToProps: state => ({
    authenticated: state.auth.authenticated,
  }),
  form: {
    form: 'usersForm',
  },
  relay: {
    query,
    variables: {
      first: 50,
    },
    create: () =>
      createFragmentContainer(Users, {
        admin: graphql`
          fragment Users_admin on Admin {
            allUsers(first: $first, email: $email) {
              edges {
                node {
                  email
                  active
                  id
                  roles(first: 50) {
                    edges {
                      node {
                        name
                        description
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/admin/Users.js